import React, { useEffect, useRef, useState } from 'react'
import { useApplicationContext } from '../../contexts/appContext'
import { useNavigate } from 'react-router-dom'

const appId = process.env.APP

export const Insights = () => {
  let token
  const { getToken, isAuthenticated, vendorSettings } = useApplicationContext()
  const containerRef = useRef(null)
  const [isInitialized, setInitialized] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (containerRef.current != null && !isInitialized) {
      if (isAuthenticated()) {
        token = getToken()

        const element = document.getElementById(`${appId}`)

        window.verifierWidget({
          domElementId: appId, // The ID of the element where the widget will be injected
          token: token,
          notAuthorizedCallback: () => {
            element.remove()
            navigate('/unAuthorised')
          },
          errorCallback: () => {
            element.remove()
            navigate('/error')
          },
          cancelCallback: () => {
            element.remove()
            navigate('/cancel')
          },
          successCallback: () => {
            element.remove()
            navigate('/success')
          },
          vendorSettings
        })
      }

      setInitialized(true)
    }
  }, [containerRef.current, isInitialized])

  return <div ref={containerRef}></div>
}
